import { useEffect, useState } from "react";

/**
 * 화면 대여섯 개짜리라 라우터 라이브러리를 두지 않는다.
 * 주소를 상태로 쓰되, 뒤로가기가 동작하도록 popstate 만 듣는다.
 *
 * 주제·입장은 메모리에만 들고 있으므로 /stance 로 직접 들어오면 갈 곳이 없다.
 * 그 경우는 화면 쪽에서 "/" 로 돌려보낸다.
 */
export function useRoute() {
  const [path, setPath] = useState(() => window.location.pathname);

  useEffect(() => {
    const onPop = () => setPath(window.location.pathname);
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  const go = (next, { replace = false } = {}) => {
    if (next === window.location.pathname) return;
    window.history[replace ? "replaceState" : "pushState"]({}, "", next);
    setPath(next);
    window.scrollTo(0, 0);
  };

  return [path, go];
}
